import { useApplicationStore } from 'app/application/infrastructure'

const useApplication = () => {
  const authorization = useApplicationStore((state) => state.authorization)
  const setAuthorization = useApplicationStore((state) => state.setAuthorization)

  return {
    authorization,
    setAuthorization,
  }
}

export default useApplication
